module.exports = __webpack_public_path__ + "media/images/icons/copy-e88a7cef263f912a5d9b17540ba61e97.svg";